export default __webpack_public_path__ + "static/media/logo.1b95eb2b.svg";